import React from "react";

import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";

class DeleteModuleModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Modal show={this.props.deletePlint} onHide={this.props.toggleDeletePlint}>
        <Modal.Header closeButton>
          <Modal.Title>Plint Configuratie Verwijderen</Modal.Title>
        </Modal.Header>
        <Form method='POST' encType='multipart/form-data' onSubmit={this.props.submitDeletePlint}>
          <Modal.Body>Bent u zeker dat u de configuratie met ID "{this.props.selectedPlint.plint_id}" wilt verwijderen?</Modal.Body>
          <Modal.Footer>
            {this.props.formErrors["submitError"] ? <Alert variant='danger'>{this.props.formErrors["submitError"]}</Alert> : null}
            <Button variant='primary' type='submit'>
              Verwijderen
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    );
  }
}

export default DeleteModuleModal;
